export function resolveMembershipPanelState(currentState, selectedIndex, action) {
  const nextIndex = selectedIndex === null || selectedIndex === undefined || selectedIndex === ''
    ? null
    : Number(selectedIndex);

  if (nextIndex === null) {
    return {
      selectedIndex: null,
      action: null,
      showEdit: false,
      showRegister: false,
    };
  }

  if (currentState?.selectedIndex === nextIndex && currentState?.action === action) {
    return {
      selectedIndex: null,
      action: null,
      showEdit: false,
      showRegister: false,
    };
  }

  return {
    selectedIndex: nextIndex,
    action,
    showEdit: action === 'edit',
    showRegister: action === 'register',
  };
}
